import React from 'react';

function RankingIcon() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 25" enableBackground="new 0 0 18 25">
      <rect x="1" y="16" fill="#404040" width="16" height="1"/>
      <rect x="1" y="12" fill="#404040" width="16" height="1"/>
      <rect x="1" y="8" fill="#404040" width="16" height="1"/>
      <polygon fill="#404040" points="13,5 9,2 5,5 "/>
      <polygon fill="#404040" points="5,20 9,23 13,20 "/>
    </svg>
  );
}

export default RankingIcon;



// WEBPACK FOOTER //
// ./src/components/icons/RankingIcon.js